import React     from 'react';
import PropTypes from 'prop-types';
import styled    from 'styled-components';

const StyledFooter = styled.div`
  justify-content : center;
  text-align      : center;
  margin          : 1rem;
`;

const Label = styled.span`
  padding   : .75rem;
  font-size : 1em;
`;

const Footer = ({ retailer, location, doorNumber }) => (
  <StyledFooter>
    <Label>
     <strong>Retailer:</strong> <span>{retailer}</span>
    </Label>
    <Label>
     <strong>Location:</strong> <span>{location}</span>
    </Label>
    <Label>
      <strong>Door:</strong> <span>{doorNumber}</span>
    </Label>
  </StyledFooter>
);

Footer.propTypes = {
  retailer   : PropTypes.string,
  location   : PropTypes.string,
  doorNumber : PropTypes.string,
};

Footer.defaultProps = {
  withoutCancel : false,
};

export default Footer;
